import { Component, OnInit } from '@angular/core';
import { Practice } from 'src/app/models/practice';
import { PracticeService } from 'src/app/services/practice.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-billing',
  templateUrl: './billing.component.html',
  styleUrls: ['./billing.component.scss']
})
export class BillingComponent implements OnInit {
  public practice: Practice;
  public practiceId;
  public loadedPractice:boolean=false;
  public seatLog;
  public seatLogLoading:boolean=true;

  constructor(
    private _practice: PracticeService,
    private _route: ActivatedRoute
  ) {
    this.practiceId = this._route.snapshot.paramMap.get("practiceId");
  }

  public getPractice(){
    this._practice.getPractice(this.practiceId).subscribe(
      res=>{
        this.practice=new Practice(res);
        this.loadedPractice=true;
      }
    );
  }

  private getSeatLog(){
    this._practice.getSeatLog(this.practiceId).subscribe(
      res=>{
        this.seatLog=res;
        this.seatLogLoading=false;
      }
    );
  }

  ngOnInit() {
    this.getPractice();
    this.getSeatLog();
  }
}
